import StarOutlineRoundedIcon from '@mui/icons-material/StarOutlineRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { Avatar, Box, Card, CardContent, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { defaultProduct, getImagePath } from "src/GeneralHelper";

interface IUserReviewProps {
	name: string;
	company: string;
	review: string;
	starRating: number;
}

function UserReview(props: IUserReviewProps) {
	const theme = useTheme();
	const { t } = useTranslation();
	const imagePath = getImagePath(defaultProduct);

	return (
		<Card className="user-review-card">
			<CardContent sx={{ p: 2, "&:last-child": { pb: 0 }, flexGrow: 1 }}>
				{/* Star Rating */}
				<Box className="review-stars">
					{new Array(props.starRating).fill(1).map((_, i) => 
						<StarRoundedIcon key={i} className="star-icon" />
					)}
					{new Array(5 - props.starRating).fill(1).map((_, i) => 
						<StarOutlineRoundedIcon key={i} className="star-icon" />
					)}
				</Box>
				
				{/* Review Text */}
				<Box mb={4} flexGrow={1}>
					<Typography 
						variant="body1" 
						className="review-text"
					>
						"{props.review}"
					</Typography>
				</Box>
				
				{/* User Info */}
				<Box className="review-user-info">
					<Avatar 
						src="landing.jpg" 
						className="review-avatar"
					/>
					<Box textAlign="left">
						<Typography 
							variant="subtitle1" 
							className="review-user-name"
						>
							{props.name}
						</Typography>
						<Typography 
							variant="body2" 
							className="review-user-company"
						>
							{props.company}
						</Typography>
					</Box>
				</Box>
			</CardContent>
		</Card>
	);
}

export default UserReview;
